import { render, staticRenderFns } from "./ModalEntregador.vue?vue&type=template&id=063a4e3c&scoped=true"
import script from "./ModalEntregador.vue?vue&type=script&lang=js"
export * from "./ModalEntregador.vue?vue&type=script&lang=js"
import style0 from "./ModalEntregador.vue?vue&type=style&index=0&id=063a4e3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063a4e3c",
  null
  
)

export default component.exports